export enum FlujoCreditoLightStatusTX {
    COMPLETED = 'COMPLETED',
    IN_PROGRESS = 'IN-PROGRESS',
    ERROR = 'ERROR'
}

export enum FlujoCreditoLightStages {
    FICHA_CLIENTE = 'Ficha cliente',
    EN_APROBACION = 'En aprobación'
}

export enum STEP_STATUS {
    CURRENT = 'CURRENT',
    DISABLED = 'DISABLED',
    COMPLETED = 'COMPLETED',
    PENDING = 'PENDING',
    DENIED = 'DENIED'
}
